var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBallMid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6348 45.9151C60.5526 63.7376 41.1774 73.2578 23.521 67.2191C5.75319 60.9871 -3.79451 41.7554 2.28776 23.9329C8.48156 6.3037 27.7044 -3.25736 45.5131 2.82219C63.1694 8.8609 72.6762 28.2451 66.6348 45.9151Z",
    fill: "url(#paint0_radial_810_77794)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_810_77794",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.7692 18.5754) rotate(17.72) scale(47.8229 47.8585)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00887753,
    stopColor: "#C9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1723,
    stopColor: "#B5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377898,
    stopColor: "#A9E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582742,
    stopColor: "#78D4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800743,
    stopColor: "#00B4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0198CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallMid);
export default __webpack_public_path__ + "static/media/ballMid.faf94e410fe25239becd947b28127e8a.svg";
export { ForwardRef as ReactComponent };